import allTransitions from 'gl-transitions'

interface GLTransitionDef {
  glsl: string
  defaultParams: Record<string, unknown>
}

const CURATED_NAMES = [
  // Cinematic
  'fadegrayscale', 'luma', 'Dreamy',
  // 3D
  'cube', 'doorway',
  // Geometric
  'pixelize', 'hexagonalize', 'squareswire', 'windowslice', 'windowblinds',
  // Organic
  'Swirl', 'ripple', 'perlin', 'morph', 'WaterDrop',
  // Directional
  'directionalwipe', 'angular', 'Radial', 'BowTieVertical', 'BowTieHorizontal',
  // Creative
  'GlitchMemories', 'burn', 'kaleidoscope', 'flyeye', 'colorphase',
  // Extra useful
  'crosswarp', 'DreamyZoom', 'CircleCrop', 'wind', 'luminance_melt',
]

const transitionMap = new Map(allTransitions.map((t: { name: string }) => [t.name, t]))

export const GL_TRANSITIONS: Record<string, GLTransitionDef> = {}

for (const name of CURATED_NAMES) {
  const t = transitionMap.get(name)
  if (t) {
    GL_TRANSITIONS[name] = { glsl: (t as any).glsl, defaultParams: (t as any).defaultParams || {} }
  }
}

export const GL_TRANSITION_NAMES = Object.keys(GL_TRANSITIONS)

export function getGLTransition(name: string): GLTransitionDef | undefined {
  const key = name.startsWith('gl_') ? name.slice(3) : name
  return GL_TRANSITIONS[key]
}

export function isGLTransition(type: string): boolean {
  return type.startsWith('gl_') && getGLTransition(type) !== undefined
}
